<template>
  <div
    class="expansion-panels-panel-content"
    :itemscope="itemScope"
    :itemprop="itemProp"
    :itemtype="itemType"
  >
    <div
      :itemprop="itemProp"
      class="expansion-panels-panel-content__text"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
  export interface Props {
    /**
     * Enable schema item scope.
     */
    itemScope?: boolean;

    /**
     * Schema item property name.
     */
    itemProp?: string;

    /**
     * Schema item type e.g. {@link https://schema.org/Question}.
     */
    itemType?: string;

    /**
     * Text block schema item property name.
     */
    textItemProp?: string;
  }

  defineProps<Props>();

  defineSlots<{
    /**
     * Content.
     */
    default(): unknown;
  }>();
</script>

<style lang="scss">
  @use '@experience/design-tokens/typography' as legacy-typography;
  @use '@experience/shared/dist/assets/adaptivity' as legacy-adaptivity;

  .expansion-panels-panel-content {
    padding-bottom: var(--alias-space-24);

    @include legacy-adaptivity.mobile {
      padding-bottom: var(--alias-space-16);
    }
  }

  .expansion-panels-panel-content__text {
    display: flex;
    flex-direction: column;
    gap: var(--alias-space-12);

    @include legacy-typography.base-500-400-regular;

    @include legacy-adaptivity.mobile {
      gap: var(--alias-space-8);

      @include legacy-typography.base-400-400-regular;
    }
  }
</style>
